import React, {useCallback, useEffect, useState} from 'react';
import {
  getAllApprovedAds,
  getAllApprovedJobs,
  getAllChapters,
  getAllEventTypesByQuery,
} from '../../../Store/Actions';
import {useDispatch, useSelector} from 'react-redux';
import PbssChapterComponent from '../../../Components/UserComponents/PbssChapter';
import {useLocation, useParams, useNavigate} from 'react-router-dom';
import moment from 'moment';
import {
  DefaultPaginationValuesForPastEvents,
  LoadMoreSize,
  createSelectionOptionsUtil,
} from './../../../Util/commonUtility';
import {
  getAllPastEvents,
  getAllUserCommitteeMembersByChapters,
  getAllUserEvents,
  getAllUsersOtherChapterEvents,
} from '../../../Store/Actions/events';
import pinSvg from '../../../Assets/svgs/pin.svg';
import selectedPinSvg from '../../../Assets/svgs/selectedPin.svg';
import {getAllEventSponsorLogos} from '../../../Store/Actions/eventRegister';
import useLocalization from '../../../Localization';
import {LANGUAGES} from '../../../Localization/LanguageContext';

const PbssChapterContainer = () => {
  const {ApplicationString, currentLanguage, changeLanguage} =
    useLocalization();
  const {chapterName, language} = useParams();

  const {getApprovedJobs} = useSelector(({jobs}) => jobs);
  const {getApprovedAds} = useSelector(({ads}) => ads);
  const {getAllEventRegistrationLogos} = useSelector(
    ({eventRegister}) => eventRegister,
  );
  const [allApprovedJobsData, setAllApprovedJobsData] = useState([]);
  const [allApprovedAdsData, setAllApprovedAdsData] = useState([]);
  const [startIndex, setStartIndex] = useState(0);
  const [endIndex, setEndIndex] = useState(2);
  const [startIndexAds, setStartIndexAds] = useState(0);
  const [endIndexAds, setEndIndexAds] = useState(3);
  const [totalJobs, setTotalJobs] = useState(0);
  const [totalAds, setTotalAds] = useState(0);
  const {
    allUserEvents,
    allUserOtherChapterEvents,
    allCommitteeMembersByChapter,
  } = useSelector(({events}) => events);
  const [eventData, setEventData] = useState([]);
  const [otherChapterEventData, setOtherChapterEventData] = useState([]);
  const [getAllEventData, setGetAllEventData] = useState();
  const [selectedChapterValue, setSelectedChapterValue] = useState('');
  const [selectedEventTypeValue, setSelectedEventTypeValue] = useState('');
  const [selectedDateValue, setSelectedDateValue] = useState('');
  const {allChapters} = useSelector(({chapters}) => chapters);
  const {allEventTypesQueryData} = useSelector(({eventTypes}) => eventTypes);
  const [chaptersList, setChaptersList] = useState([]);
  const [eventTypesList, setEventTypesList] = useState([]);
  const [countData, setCountData] = useState(LoadMoreSize);
  const [countLoadMoreData, setCountLoadMoreData] = useState(2);
  const [totalEventCount, setTotalEventCount] = useState(0);
  const [normalizedName, setNormalizedName] = useState(chapterName);
  const [pastEventData, setPastEventData] = useState();
  const [getAllPastEventData, setGetAllPastEventData] = useState();
  const {allPastEvents} = useSelector(({events}) => events);
  const [selectedYearValue, setSelectedYearValue] = React.useState('');
  const [allEventSponsorLogos, setEventSponsorLogos] = useState();
  const [pagination, setPagination] = React.useState({
    page: DefaultPaginationValuesForPastEvents.PAGE,
    pagecount: DefaultPaginationValuesForPastEvents.PAGE_SIZE,
    totalPages: DefaultPaginationValuesForPastEvents.TOTAL_PAGES,
  });
  let dispatch = useDispatch();
  const [dateToggle, setdateToggle] = useState(false);
  const [totalPastEventsPages, setTotalPastEventsPages] = useState();
  const [fetchedChapterIds, setFetchedChapterIds] = useState([]);
  const [chapterWiseCommitteeData, setChapterWiseCommitteeData] = useState([]);
  const [chapterId, setChapterId] = useState();
  const [chapterHeading, setChapterHeading] = useState();
  const [chapterContent, setChapterContent] = useState();
  const [chapterFullName, setChapterFullName] = useState();
  const [heroLinkText, setHeroLinkText] = useState();
  const [japaneseHeroLinkText, setJapaneseHeroLinkText] = useState();
  const [japanese, setJapanese] = useState(language === 'ja');

  const handleLanguageSwitch = (isJapanese) => {
    if (isJapanese) {
      setJapanese(true);
      changeLanguage(LANGUAGES.JA);
      localStorage.setItem('pbssLanguage', LANGUAGES.JA);
    } else {
      setJapanese(false);
      changeLanguage(LANGUAGES.EN);
      localStorage.setItem('pbssLanguage', LANGUAGES.EN);
    }
  };

  useEffect(() => {
    if (currentLanguage === 'ja') {
      setJapanese(true);
    } else {
      setJapanese(false);
    }
  }, [currentLanguage]);

  const dateOrderHandler = () => {
    if (dateToggle) {
      dispatch(
        getAllUserEvents(selectedEventTypeValue, selectedChapterValue, 'desc'),
      );
    } else {
      dispatch(
        getAllUserEvents(selectedEventTypeValue, selectedChapterValue, 'asc'),
      );
    }
    setdateToggle(!dateToggle);
  };
  useEffect(() => {
    dispatch(
      getAllUserEvents(
        selectedChapterValue,
        selectedEventTypeValue,
        selectedDateValue,
      ),
    );
  }, []);

  useEffect(() => {
    if (japanese) {
      const japaneseChapterData = allChapters?.data?.chapters?.find(
        (obj) => obj.name === 'Japan Japanese',
      );
      dispatch(getAllUserCommitteeMembersByChapters(japaneseChapterData?.id));
    } else {
      if (chapterId) {
        dispatch(getAllUserCommitteeMembersByChapters(chapterId));
      }
    }
  }, [chapterId, japanese]);

  useEffect(() => {
    if (allCommitteeMembersByChapter) {
      setChapterWiseCommitteeData(
        allCommitteeMembersByChapter?.data?.committeeMembers,
      );
    }
  }, [allCommitteeMembersByChapter]);

  // Map custom tooltip for chapter selection
  const allMapStars = document.querySelectorAll('.jvm-marker');
  const filteredChapter = allChapters?.data?.chapters.filter(
    (chap) => chap?.is_visible_on_map,
  );

  let mapTooltip;
  allMapStars.forEach((star) => {
    star.addEventListener('mouseover', (e) => {
      const tip = document.querySelector('.jvm-tooltip');
      if (!tip) {
        mapTooltip = document.createElement('div');
        mapTooltip.classList.add('map-tooltip');
        mapTooltip.style.left = `${e.clientX - 40}px`;
        mapTooltip.style.top = `${e.clientY - 30}px`;
        mapTooltip.textContent =
          filteredChapter[e.target.getAttribute('data-index')]?.name;
        document.body.appendChild(mapTooltip);
      }
    });

    star.addEventListener('mouseleave', (e) => {
      if (mapTooltip) {
        document.body.removeChild(mapTooltip);
        mapTooltip = null;
      }
    });
  });

  // Highlight the selected chapter on the map
  useEffect(() => {
    let activeChapIndex = filteredChapter?.findIndex(
      (chap) => chap?.normalized_name === normalizedName,
    );
    let mapStar;
    const mouseEnterHandler = (e) => {
      e.target.setAttribute('href', selectedPinSvg);
    };
    const mouseLeaveHandler = (e) => {
      e.target.setAttribute('href', selectedPinSvg);
    };

    const intervalId = setInterval(() => {
      mapStar = document.querySelector(
        `.jvm-marker[data-index="${activeChapIndex}"]`,
      );
      if (mapStar) {
        mapStar.setAttribute('href', selectedPinSvg);
        mapStar?.addEventListener('mouseenter', mouseEnterHandler);
        mapStar?.addEventListener('mouseleave', mouseLeaveHandler);
        clearInterval(intervalId);
      }
    }, 50);

    return () => {
      activeChapIndex = null;
      mapStar?.setAttribute('href', pinSvg);
      mapStar?.removeEventListener('mouseenter', mouseEnterHandler);
      mapStar?.removeEventListener('mouseleave', mouseLeaveHandler);
    };
  }, [normalizedName, allChapters]);

  const handleNext = () => {
    if (endIndex + 1 < totalJobs) {
      setStartIndex(endIndex + 1);
      setEndIndex(endIndex + 3);
    }
  };

  const handlePrev = () => {
    if (startIndex > 0) {
      setStartIndex(startIndex - 3);
      setEndIndex(endIndex - 3);
    }
  };
  const handleNextAds = () => {
    if (endIndexAds + 1 < totalAds) {
      setStartIndexAds(endIndexAds + 1);
      setEndIndexAds(endIndexAds + 4);
    }
  };

  const handlePrevAds = () => {
    if (startIndexAds > 0) {
      setStartIndexAds(startIndexAds - 4);
      setEndIndexAds(endIndexAds - 4);
    }
  };

  useEffect(() => {
    if (getAllEventRegistrationLogos) {
      setEventSponsorLogos(getAllEventRegistrationLogos);
    }
  }, [getAllEventRegistrationLogos]);

  useEffect(() => {
    if (getApprovedJobs) {
      const Data = getApprovedJobs?.data?.jobs?.slice(startIndex, endIndex + 1);
      setAllApprovedJobsData(Data);
      setTotalJobs(getApprovedJobs?.data?.totalCount);
    } else {
      dispatch(getAllApprovedJobs());
    }
  }, [getApprovedJobs, startIndex, endIndex]);

  useEffect(() => {
    if (getApprovedAds) {
      const Data = getApprovedAds?.data?.ads?.slice(
        startIndexAds,
        endIndexAds + 1,
      );
      setAllApprovedAdsData(Data);
      setTotalAds(getApprovedAds?.data?.totalCount);
    } else {
      dispatch(getAllApprovedAds());
    }
  }, [getApprovedAds, startIndexAds, endIndexAds]);

  useEffect(() => {
    const id = allChapters?.data?.chapters?.find(
      (item) => item.normalized_name === chapterName,
    )?.id;
    setChapterId(id);
    // Banner / welcome text should use Display Name (normalized_name), not Name.
    setNormalizedName(
      allChapters?.data?.chapters?.find(
        (item) => item.normalized_name === chapterName,
      )?.normalized_name,
    );
    if (!fetchedChapterIds.includes(id)) {
      dispatch(
        getAllUserEvents(
          selectedEventTypeValue,
          id,
          selectedDateValue,
          '',
          japanese,
        ),
      );
      dispatch(getAllUsersOtherChapterEvents(selectedDateValue));
      setFetchedChapterIds([...fetchedChapterIds, id]);
    } else {
      const allEvents = allUserEvents?.data?.events;
      const mapEventData = (item) => ({
        key: item.id,
        status: item.status,
        sponsorshipAvailable: `${
          Array.isArray(item.sponsors) ? item.sponsors.length : 0
        } Sponsorship Available`,
        speakers: Array.isArray(item.speakers)
          ? item.speakers.map((speakers) => {
              return speakers.first_name + ' ' + speakers.last_name + ',';
            })
          : '',
        date: moment(item.date).utcOffset(0).format('MMM DD'),
        dateObject: item.formattedDateTime,
        eventName: item.name,
        eventDetails: item.details,
        location: item.place,
        registerText:
          Number(item.status) === 2 ? 'Registration Closed' : 'Register Now',
        price: '295',
        category: 'PBSS International Boston - PBSS',
        eventType: item.event_type_name,
        eventChapter: item?.local_chapter_name,
        localChapter: item?.local_chapter_id,
        is_online: item?.is_online,
        is_available_for_webcast: item?.is_available_for_webcast,
        online_for_chapters: item?.online_for_chapters,
        webcast_available_for_chapters: item?.webcast_available_for_chapters,
      });

      const otherChapterEventData =
        allUserOtherChapterEvents?.data?.events
          ?.map(mapEventData)
          ?.filter((obj) => obj.localChapter !== id) ?? [];

      const chapterHasAccess = (event) => {
        const onlineChapters = event?.online_for_chapters;
        const webcastChapters = event?.webcast_available_for_chapters;

        const isOnlineForChapter =
          event.is_online && onlineChapters?.includes(chapterFullName);
        const isWebcastForChapter =
          event.is_available_for_webcast &&
          webcastChapters?.includes(chapterFullName);

        return isOnlineForChapter || isWebcastForChapter;
      };

      let otherChapterEventDataWithOnlineAndWebcast = [];
      otherChapterEventData.forEach((event) => {
        const isAccess = chapterHasAccess(event);
        if (isAccess) {
          otherChapterEventDataWithOnlineAndWebcast.push(event);
        }
      });
      setGetAllEventData(allEvents);
      setOtherChapterEventData(otherChapterEventDataWithOnlineAndWebcast);
      setTotalEventCount(allUserEvents?.data?.totalCount);
    }
    return () => {
      setFetchedChapterIds(
        fetchedChapterIds.filter((chapterId) => chapterId !== id),
      );
    };
  }, [
    allUserEvents,
    countData,
    chapterName,
    selectedEventTypeValue,
    selectedDateValue,
    allChapters,
    japanese,
  ]);

  useEffect(() => {
    if (getAllEventData) {
      const updatedEventData = getAllEventData.map((item) => {
        return {
          key: item.id,
          status: item.status,
          sponsorshipAvailable: `${
            Array.isArray(item.sponsors) ? item.sponsors.length : 0
          } Sponsorship Available`,
          speakers: Array.isArray(item.speakers)
            ? item.speakers.map((speakers) => {
                return speakers.first_name + ' ' + speakers.last_name + ',';
              })
            : '',
          date: moment(item.date).utcOffset(0).format('MMM DD'),
          dateObject: item.formattedDateTime,
          eventName: item.name,
          eventDetails: item.details,
          location: item.place,
          registerText:
            Number(item.status) === 2 ? 'Registration Closed' : 'Register Now',
          price: '295',
          category: 'PBSS International Boston - PBSS',
          eventType: item.event_type_name,
          eventChapter: item?.local_chapter_name,
        };
      });
      setEventData(updatedEventData);
    }
  }, [getAllEventData]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, [chapterName]);

  const handleSetCHapterHeading = useCallback(
    (chapterData) => {
      const currentChapterData = chapterData?.find(
        (obj) => obj.id === chapterId,
      );
      const japaneseChapterData = allChapters?.data?.chapters?.find(
        (obj) => obj.name === 'Japan Japanese',
      );
      const currentChapterName = currentChapterData?.name;
      setChapterFullName(currentChapterName);
      setHeroLinkText(currentChapterData?.hero_link_text || null);
      setJapaneseHeroLinkText(japaneseChapterData?.hero_link_text || null);
      const heading = ApplicationString['chapterPage.chapterHeading.title'];
      setChapterHeading(heading);
      if (japanese) {
        setChapterContent({
          special_announcement: japaneseChapterData?.special_announcement,
          sponsorship_info: japaneseChapterData?.sponsorship_info
            ? JSON.parse(japaneseChapterData?.sponsorship_info)
            : null,
          about_chapter: japaneseChapterData?.about_chapter,
          mission: japaneseChapterData?.mission,
          contact_us: japaneseChapterData?.contact_us,
          highlights_ids: japaneseChapterData?.highlights_ids,
        });
      } else {
        setChapterContent({
          special_announcement: currentChapterData?.special_announcement,
          sponsorship_info: currentChapterData?.sponsorship_info
            ? JSON.parse(currentChapterData?.sponsorship_info)
            : null,
          about_chapter: currentChapterData?.about_chapter,
          mission: currentChapterData?.mission,
          contact_us: currentChapterData?.contact_us,
          highlights_ids: currentChapterData?.highlights_ids,
        });
      }
    },
    [chapterId, japanese],
  );

  useEffect(() => {
    if (allChapters) {
      const visibleChapters = allChapters?.data?.chapters?.filter((chapter) => {
        return chapter?.is_visible_on_map === true;
      });
      const chapters = createSelectionOptionsUtil(
        visibleChapters,
        'id',
        'name',
      );
      handleSetCHapterHeading(visibleChapters);
      setChaptersList(chapters);
    } else {
      dispatch(getAllChapters());
    }
  }, [allChapters, japanese, dispatch]);

  useEffect(() => {
    if (allChapters && chapterId) {
      const visibleChapters = allChapters?.data?.chapters?.filter((chapter) => {
        return chapter?.is_visible_on_map === true;
      });
      handleSetCHapterHeading(visibleChapters);
    }
  }, [allChapters, japanese, chapterId]);

  useEffect(() => {
    if (allEventTypesQueryData?.forMaster) {
      const eventTypes = createSelectionOptionsUtil(
        allEventTypesQueryData?.forMaster?.data?.eventTypes?.filter(
          (obj) => obj.name?.toLowerCase() !== 'webcast',
        ),
        'id',
        'name',
      );
      setEventTypesList(eventTypes);
    } else {
      dispatch(
        getAllEventTypesByQuery('', '', '', {
          page: 1,
          pageCount: 100,
        }),
      );
    }
  }, [allEventTypesQueryData?.forMaster, dispatch]);

  useEffect(() => {
    dispatch(getAllEventSponsorLogos());
  }, []);

  const handlePaginationChange = (current, pageSize) => {
    setPagination({
      ...pagination,
      page: current,
    });
  };
  const handleYearFilter = (value) => {
    if (value === 'clear') {
      dispatch(getAllPastEvents(pagination, ''));
      setSelectedYearValue('');
    } else {
      dispatch(getAllPastEvents(pagination, value));
      setSelectedYearValue(value);
    }
  };

  useEffect(() => {
    if (allPastEvents) {
      const Data = allPastEvents?.data?.events;
      setGetAllPastEventData(Data);
      setPagination({
        ...pagination,
        page: allPastEvents?.data?.currentPage,
        totalPages: allPastEvents?.data?.totalPage,
        totalCount: allPastEvents?.data?.totalCount,
      });
      setTotalPastEventsPages(allPastEvents?.data?.totalPage);
    } else {
      dispatch(getAllPastEvents(pagination, selectedYearValue));
    }
  }, [allPastEvents]);

  useEffect(() => {
    if (getAllPastEventData) {
      const updatedPastEventData = getAllPastEventData.map((item) => {
        return {
          key: item.id,
          name: item.name,
          event_date: moment(item.event_start_date_time)
            .utcOffset(0)
            .format('DD MMM YYYY'),
          event_type: item.event_type_name,
          chapter_name: item?.local_chapter_normalized_name
            ? item?.local_chapter_normalized_name
            : item.local_chapter_name,
        };
      });
      setPastEventData(updatedPastEventData);
    }
  }, [getAllPastEventData]);

  const filteredEvents = eventData;

  const handleChapterFilter = (value) => {
    if (value === 'clear') {
      dispatch(getAllUserEvents(selectedEventTypeValue, '', selectedDateValue));
      setSelectedChapterValue('');
    } else {
      dispatch(
        getAllUserEvents(selectedEventTypeValue, value, selectedDateValue),
        setSelectedChapterValue(value),
      );
    }
    setCountLoadMoreData(2);
  };
  const handleEventTypeFilter = (value) => {
    if (value === 'clear') {
      dispatch(getAllUserEvents('', selectedChapterValue, selectedDateValue));
      setSelectedEventTypeValue('');
    } else {
      dispatch(
        getAllUserEvents(value, selectedChapterValue, selectedDateValue),
        setSelectedEventTypeValue(value),
      );
    }
    setCountLoadMoreData(2);
  };

  const handleLoadMore = () => {
    setCountData(countData * 2);
    setCountLoadMoreData(countLoadMoreData * 2);
  };

  const filterBydate = (selectedDate) => {
    setCountLoadMoreData(2);
    const StartDate = Array.isArray(selectedDate)
      ? moment(new Date(selectedDate[0])).format('YYYY-MM-DD')
      : '';
    const EndDate = Array.isArray(selectedDate)
      ? moment(new Date(selectedDate[1])).format('YYYY-MM-DD')
      : '';
    const FullDate = StartDate + ',' + EndDate;
    setSelectedDateValue(FullDate);
    dispatch(
      getAllUserEvents(selectedEventTypeValue, selectedChapterValue, FullDate),
    );
  };

  return (
    <PbssChapterComponent
      allEventSponsorLogos={allEventSponsorLogos}
      allApprovedJobsData={allApprovedJobsData}
      allApprovedAdsData={allApprovedAdsData}
      handleNext={handleNext}
      handlePrev={handlePrev}
      handleNextAds={handleNextAds}
      handlePrevAds={handlePrevAds}
      eventData={eventData}
      totalEventCount={totalEventCount}
      handleLoadMore={handleLoadMore}
      normalizedName={normalizedName}
      pastEventData={pastEventData}
      handleChapterFilter={handleChapterFilter}
      handleEventTypeFilter={handleEventTypeFilter}
      filterBydate={filterBydate}
      chaptersList={chaptersList}
      eventTypeList={eventTypesList}
      countLoadMoreData={countLoadMoreData}
      filteredEvents={filteredEvents}
      pagination={pagination}
      handleYearFilter={handleYearFilter}
      handlePaginationChange={(page, pageSize) => {
        handlePaginationChange(page, pageSize);
      }}
      selectedEventTypeValue={selectedEventTypeValue}
      selectedChapterValue={selectedChapterValue}
      selectedDateValue={selectedDateValue}
      selectedYearValue={selectedYearValue}
      dateToggle={dateToggle}
      dateOrderHandler={dateOrderHandler}
      totalPastEventsPages={totalPastEventsPages}
      chapterWiseCommitteeData={chapterWiseCommitteeData}
      chapterHeading={chapterHeading}
      chapterContent={chapterContent}
      chapterFullName={chapterFullName}
      otherChapterEventData={otherChapterEventData}
      handleLanguageSwitch={handleLanguageSwitch}
      heroLinkText={heroLinkText}
      japaneseHeroLinkText={japaneseHeroLinkText}
    />
  );
};

export default PbssChapterContainer;
